"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ = _interopRequireWildcard(require("./renderers/0-3"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MobiledocReactRenderer =
/*#__PURE__*/
function () {
  function MobiledocReactRenderer(_ref) {
    var _ref$atoms = _ref.atoms,
        atoms = _ref$atoms === void 0 ? [] : _ref$atoms,
        _ref$cards = _ref.cards,
        cards = _ref$cards === void 0 ? [] : _ref$cards,
        _ref$markups = _ref.markups,
        markups = _ref$markups === void 0 ? [] : _ref$markups,
        _ref$sections = _ref.sections,
        sections = _ref$sections === void 0 ? [] : _ref$sections,
        _ref$additionalProps = _ref.additionalProps,
        additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? 'Mobiledoc' : _ref$className;

    _classCallCheck(this, MobiledocReactRenderer);

    this.options = {
      atoms: atoms,
      cards: cards,
      markups: markups,
      sections: sections,
      className: className,
      additionalProps: additionalProps
    };
  }

  _createClass(MobiledocReactRenderer, [{
    key: "render",
    value: function render(mobiledoc) {
      var version = mobiledoc.version;

      switch (version) {
        case _.MOBILE_DOC_VERSION_0_3_0:
        case _.MOBILE_DOC_VERSION_0_3_1:
          return new _["default"](mobiledoc, this.options).render();

        default:
          return null;
      }
    }
  }]);

  return MobiledocReactRenderer;
}();

exports["default"] = MobiledocReactRenderer;